import React, { useEffect, useState } from "react";
import ListLineas from "../plan/components/ListLineas";
import Container from "../../components/Container";
import BotonAtomico from "../../components/PartesAtomicas/BotonAtomico";
import CustomModal from "@sistemas.mundo/custom-modal";
import useUrlFirmadaPruebaVida from "../../queries/config/useUrlFirmadaPruebaVida";
import { Box } from "@mui/material";
import { useUsuario } from "../../context/usuarioContext";
import useLineasPendientes from "../../queries/config/useLineasPendiente";
import useEnviarCap from "../../queries/plan/useEnviarCap";
import useListarLineas from "../../queries/plan/useListarLineas";
import CustomForm from "@sistemas.mundo/custom-form";
import useGuardarCap from "../../queries/plan/useGuardarCap";
import useEnviarSms from "../../queries/plan/useEnviarSms";
import useGuardarSms from "../../queries/plan/useGuardarSms";
import { toast } from "react-toastify";

const ActivacionLineas = () => {
  const apiRecordatorioLineas = useLineasPendientes();
  const apiEnviarCap = useEnviarCap();
  const apiEnviarSms = useEnviarSms();
  const apiGuardarSms = useGuardarSms();
  const apiLineas = useListarLineas();
  const apiGuardarCap = useGuardarCap();
  const { contratoSeleccionado, usuario } = useUsuario();
  const urlFirmada = useUrlFirmadaPruebaVida();
  const [modalPruebaVida, setModalPruebaVida] = useState(false);
  const [modalIngresarCap, setModalIngresarCap] = useState(false)
  const [modalIngresarSmS, setModalIngresarSmS] = useState(false)

  const [url, setUrl] = useState(null);

  const [requiereCap, setrequiereCap] = useState(false)
  const [requiereSms, setrequiereSms] = useState(false)

  const [lineas, setLineas] = useState([])

  useEffect(() => {
    if (urlFirmada.isSuccess) {
      setUrl(urlFirmada.data.success.descripcionRespuesta);
    }
  }, [urlFirmada.isSuccess]);

  useEffect(() => {
    if (apiLineas.isSuccess) {
      setLineas(apiLineas.data.success.descripcionRespuesta)
    }
  }, [apiLineas.isSuccess])


 
  useEffect(() => {
    if (contratoSeleccionado) {
     
      apiLineas.mutate({ contrato_id: contratoSeleccionado.contrato_id_padre ?? contratoSeleccionado.id_contrato })
      apiRecordatorioLineas.mutate({ id: contratoSeleccionado.contrato_id_padre ?? contratoSeleccionado.id_contrato });
    }
  }, [contratoSeleccionado]);

  const [recordatorioLineas, setRecordatorioLineas] = useState(false);

  useEffect(() => {
    if (apiRecordatorioLineas.isSuccess) {
      if (apiRecordatorioLineas.data && apiRecordatorioLineas.data.success) {

        setrequiereCap(apiRecordatorioLineas.data.success.descripcionRespuesta.requiereCap)
        setrequiereSms(apiRecordatorioLineas.data.success.descripcionRespuesta.requiereSmS)

        setRecordatorioLineas(
          apiRecordatorioLineas.data.success.descripcionRespuesta
            .lineasParaActivar
        );
      } else {
        setRecordatorioLineas(false);
      }
    }
  }, [apiRecordatorioLineas.isSuccess]);

  useEffect(() => {
    if (modalPruebaVida) {
      var params = {
        tipo: 9,
        contrato_id: contratoSeleccionado.contrato_id_padre ?? contratoSeleccionado.id_contrato,
      };

      var paramsEncoded = btoa(JSON.stringify(params));
      urlFirmada.mutate({
        contrato_id: contratoSeleccionado.contrato_id_padre ?? contratoSeleccionado.id_contrato,
        contrato: contratoSeleccionado.codigo,
        rut: usuario.RutClient,
        nivel: 3,
        clie_correo: usuario.Correo,
        clie_numero: usuario.Telefono,
        clie_nombre:
          usuario.Nombres + " " + usuario.ApPaterno ??
          "" + " " + usuario?.ApMaterno ??
          "",
        tico_id: 9,
        key: paramsEncoded,
      });
    }
  }, [modalPruebaVida]);

  const handleIngresarCap = async () => {

    let arrSolicitud = lineas.map((item) => {
      let sol = item.solicitud_portabilidad ?? null;
      if (sol && (sol.necesita_cap || sol.posible_reenvio)) {
        return item.solicitud_portabilidad?.id_solicitud;
      }
    });

    arrSolicitud = arrSolicitud.filter((el) => el);

    const response = await apiEnviarCap.mutateAsync({ solicitudes: arrSolicitud });

    if (response.success) {
      setModalIngresarCap(true)
    }

  }

  const handleIngreseSms = async () => {
    let arrSolicitud = lineas.map((item) => {
      let sol = item.solicitud_portabilidad ?? null;

      if (sol && (sol.necesita_sms || sol.posible_reenvio) && item.principal) {
        return item.solicitud_portabilidad?.id_solicitud;
      }
    });

    arrSolicitud = arrSolicitud.filter((el) => el);

    const response = await apiEnviarSms.mutateAsync({ solicitudes: arrSolicitud });

    if (response.success) {
      setModalIngresarSmS(true)
    }
  }

  const camposFormularioLineas = (postpago = false) => {

    var arrSolicitud = [];

    if (postpago) {
  
      arrSolicitud = lineas.map((item) => {
        let sol = item.solicitud_portabilidad ?? null;
        if (sol && (sol.necesita_sms || sol.posible_reenvio) && item.principal) {
          return item;
        }
      });
    
    } else {
    
      arrSolicitud = lineas.map((item) => {
        let sol = item.solicitud_portabilidad ?? null;
        if (sol && (sol.necesita_cap || sol.posible_reenvio)) {
          return item;
        }
      });
    }

    arrSolicitud = arrSolicitud.filter((el) => el);

    const form = arrSolicitud.map((item, index) => ({
      elements: [
        {
          name: `codigo_linea_${index + 1}`,
          label: `línea ${item.lineaFull}`,
          placeholder: "Ingrese el código",
          value: null,
          type: "text",
          required: true,
          minLength: 4,
          maxLength: 4,
          grid: {
            xs: 12,
            md: 12,
            lg: 12,
            xl: 12,
          },
        },
      ],
    }));

    return form;
  };

  const onSubmitCap = async (data) => {


    let arrSolicitud = lineas.map((item) => {
      let sol = item.solicitud_portabilidad ?? null;
      if (sol && (sol.necesita_cap || sol.posible_reenvio)) {
        return item.solicitud_portabilidad;
      }
    });
    arrSolicitud = arrSolicitud.filter((el) => el);
    arrSolicitud = arrSolicitud.map((sol, index) => {
      const capKey = `codigo_linea_${index + 1}`;
      return {
        ...sol,
        cap: data[capKey] || null,
      };
    });

 
    const response = await apiGuardarCap.mutateAsync({ solicitudes: arrSolicitud })

    setModalIngresarCap(false)
    apiLineas.mutate({ contrato_id: contratoSeleccionado.contrato_id_padre ?? contratoSeleccionado.id_contrato })
    apiRecordatorioLineas.mutate({ id: contratoSeleccionado.contrato_id_padre ?? contratoSeleccionado.id_contrato });
  }

  const onSubmitSms = async (data) => {


    let arrSolicitud = lineas.map((item) => {
      let sol = item.solicitud_portabilidad ?? null;
      if (sol && (sol.necesita_sms || sol.posible_reenvio) && item.principal) {
        return item.solicitud_portabilidad;
      }
    });
    arrSolicitud = arrSolicitud.filter((el) => el);
    arrSolicitud = arrSolicitud.map((sol, index) => {
      const capKey = `codigo_linea_${index + 1}`;
      return {
        ...sol,
        codigo: data[capKey] || null,
      };
    });

    const response = await apiGuardarSms.mutateAsync({ solicitudes: arrSolicitud })

    if(response.success.descripcionRespuesta.respuesta[0].estado_solicitud){
      setModalIngresarSmS(false)
      apiLineas.mutate({ contrato_id: contratoSeleccionado.contrato_id_padre ?? contratoSeleccionado.id_contrato })
      apiRecordatorioLineas.mutate({ id: contratoSeleccionado.contrato_id_padre ?? contratoSeleccionado.id_contrato });
    }
    else{
      toast.error("Código incorrecto");
    }
    
  }

  return (
    <div>
      {" "}
      {recordatorioLineas ? (
        <>
          <Container label={"Mis Números"}>
            <ListLineas />

            {requiereCap  ?  <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "300px" }}>
                <BotonAtomico
                  label="Ingresar Código Prepago"
                  onClick={() => handleIngresarCap()}
                />
              </div>
            </div> : requiereSms && <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "300px" }}>
                <BotonAtomico
                  label="Ingresar Código Postpago"
                  onClick={() => handleIngreseSms()}
                />
              </div>
            </div>}


            {!requiereCap && !requiereSms && <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "200px" }}>
                <BotonAtomico
                  label="Activar"
                  onClick={() => setModalPruebaVida(true)}
                />
              </div>
            </div>}

          </Container>

          <CustomModal
            fullWidth={true}
            isModalOpened={modalIngresarCap}
            handleCloseModal={() => {
              setModalIngresarCap(false);
            }}
            titleStyle={{
              height: "20px",
              display: "flex",
              alignItems: "flex-end",
              borderRadius: "2px",
            }}
            body={
              <>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <h2 style={{ color: "#00657D", textAlign: "center" }}>
                    Ingrese los códigos para líneas Prepago
                  </h2>
                </div>

                <CustomForm
                  formId="formulario_codigos_cap"
                  campos={camposFormularioLineas()}
                  showClearForm={false}
                  onSubmit={onSubmitCap}
                  submitButtonText={"Ingresar Códigos"}
                  tooltipSubmitBtn={"Ingresar Códigos"}
                  submitButtonPosition="center"
                  fullButtonSubmitWidth={true}
                  resetCamposOnSubmit={false}
                />
              </>
            }
            showOk={false}
            showCancel={true}
            maxWidth="md"
          />


          <CustomModal
            fullWidth={true}
            isModalOpened={modalIngresarSmS}
            handleCloseModal={() => {
              setModalIngresarSmS(false);
            }}
            titleStyle={{
              height: "20px",
              display: "flex",
              alignItems: "flex-end",
              borderRadius: "2px",
            }}
            body={
              <>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <h2 style={{ color: "#00657D", textAlign: "center" }}>
                    Ingrese los códigos para líneas postpago
                  </h2>
                </div>

                <CustomForm
                  formId="formulario_codigos_sms"
                  campos={camposFormularioLineas({ postpago: true })}
                  showClearForm={false}
                  onSubmit={onSubmitSms}
                  submitButtonText={"Ingresar Códigos"}
                  tooltipSubmitBtn={"Ingresar Códigos"}
                  submitButtonPosition="center"
                  fullButtonSubmitWidth={true}
                  resetCamposOnSubmit={false}
                />
              </>
            }
            showOk={false}
            showCancel={true}
            maxWidth="md"
          />

          <CustomModal
            fullWidth={true}
            isModalOpened={modalPruebaVida}
            handleCloseModal={() => {
              setModalPruebaVida(false);
            }}
            titleStyle={{
              height: "20px",
              display: "flex",
              alignItems: "flex-end",
              borderRadius: "2px",
            }}
            body={
              <>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <h2 style={{ color: "#00657D", textAlign: "center" }}>
                    Validación de identidad
                  </h2>
                </div>
                <Box pb={3} display="flex" justifyContent={"center"}>
                  {url && (
                    <img
                      src={`data:image/png;base64,${url.qr}`}
                      alt="QR Code"
                    />
                  )}
                </Box>
                <Box pb={3}>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <BotonAtomico
                      label="Abrir Enlace"
                      colorCorp={0}
                      onClick={() => {
                        window.open(url?.respuesta ?? null, "_blank");
                      }}
                    />
                  </div>
                </Box>
              </>
            }
            showOk={false}
            showCancel={true}
            maxWidth="md"
          />
        </>
      ) : (
        <Container label={"Mis Números"}>


          <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
            No tiene líneas para activar
          </div>
        </Container>
      )}
    </div>
  );
};

export default ActivacionLineas;
